/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from "axios";
var apiURL = __API_BASE__;



// 环境的切换
axios.defaults.baseURL = apiURL;
/*axios.defaults.timeout = 50000*/
// post请求头
/*axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'*/
// 请求拦截器


function setInterceptors(instance) {
    instance.interceptors.request.use(config => {
        return config
    })

    instance.interceptors.response.use(response => {
        return Promise.resolve(response.data);
    })
}


/**
 * post请求
 */
export const postRequest = (url, data, headers = { "Content-Type": "application/json" }) => {
    return request({ data, url, method: 'post', headers: headers });
};

/**
 * get请求
 */
export const getRequest =(url, params, headers = {})=> {
    return request({ url, method: 'get', params, headers: headers });
};

const request = (config) => {


    // 创建axios实例
    const service = axios.create({
        // axios中请求配置有baseURL选项，表示请求URL公共部分
        baseURL: apiURL,
        // 超时（毫秒）
        timeout: 10000,
        headers: config.headers,
        responseEncoding: 'utf8',
    });
    setInterceptors(service)
    return service.request(config);
};


